import { newThemeOptions } from 'src/theme/theme';

const initialColours = Object.values(newThemeOptions.newPalette.accordion);
const hoverColors = Object.values(newThemeOptions.newPalette.accordionHover);
const initialBorderColours = Object.values(newThemeOptions.newPalette.chart);

export const getTagTypeColor = (index: number) => {
  if (index < initialColours.length) {
    return initialColours[index];
  } else {
    return initialColours[index % initialColours.length];
  }
};

export const getTagTypeBorderColor = (index: number) => {
  let borderColor;
  if (index < initialBorderColours.length) {
    borderColor = initialBorderColours[index];
  } else {
    borderColor = initialBorderColours[index % initialBorderColours.length];
  }

  if (
    borderColor === newThemeOptions.newPalette.chart.neutral ||
    borderColor === newThemeOptions.newPalette.chart.white
  ) {
    return newThemeOptions.newPalette.neutral.N800;
  }

  return borderColor;
};

export const getTagTypeHoverColor = (index: number) => {
  let hoverColor;
  if (index < hoverColors.length) {
    hoverColor = hoverColors[index];
  } else {
    hoverColor = hoverColors[index % hoverColors.length];
  }
  if (hoverColor === newThemeOptions.newPalette.chart.neutral) {
    return newThemeOptions.newPalette.neutral.N400;
  }
  if (hoverColor === newThemeOptions.newPalette.chart.white) {
    return newThemeOptions.newPalette.neutral.N200;
  }
  return hoverColor;
};
